module.exports = __webpack_public_path__ + "static/media/icon_chuangxin.7b1c0b8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/icon_chuangxin.svg
// module id = 228
// module chunks = 0